// @core/api/endpoints/workflow/delete_pipeline_policy.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/workflow';

/**
 * Delete pipeline policy
 * Deletes a pipeline policy. Scope entities will fall through to the next ancestor policy.
 */
export async function DeletePipelinePolicy(
  policy_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/pipeline-policies/:policy_id`;
  requestPath = requestPath.replace(':policy_id', encodeURIComponent(policy_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
